module.exports = __webpack_public_path__ + "static/media/startRightDark.48c4015c.svg";